import {Injectable} from "@angular/core";
import {HttpService} from "../technique/http.service";
import {UtilsService} from "../../utils/utils.service";
import {Observable} from "rxjs";
import {ResponseWrapper} from "../../suppliers/wrappers/response-wrapper";
import {GestionAuthentificationDto} from "../../dtos/gestion-authentification/gestion-authentification-dto";
import {catchError} from "rxjs/operators";
import {saveAs as fs_saveAs} from "file-saver";
import {HttpHeaders} from "@angular/common/http";

export const URL_PURGE_INACTIVE_ARTICLE = 'dolrest/administration/purgeInactiveArticles';
export const URL_UPDATE_PRODUITS_ARTICLES = 'dolrest/administration/updateProduitsArticles';
export const URL_GESTION_AUTHENTIFICATION = 'dolrest/administration/authentification';
export const URL_MAJ_ALLERGENES = 'dolrest/administration/majAllergenes';

@Injectable({
  providedIn: 'root'
})
export class AdministrationService {
  constructor(private httpSvc: HttpService,
              public utils: UtilsService) { }

  /**
   * Suppression des articles inactifs
   * @returns {Observable<void>}
   */
  purgeInactiveArticles = (): Observable<ResponseWrapper<string>> => {
    return this.httpSvc.get(URL_PURGE_INACTIVE_ARTICLE, null);
  }

  /**
   * Mise à jour des produits articles
   * @returns {Observable<void>}
   */
  updateProduitsArticles = () : Observable<ResponseWrapper<string>> => {
    return this.httpSvc.get(URL_UPDATE_PRODUITS_ARTICLES, null);
  }

  /**
   * Mise à jour des allergènes sur les produits
   * @returns {Observable<void>}
   */
  majAllergenes = () : Observable<ResponseWrapper<string>> => {
    return this.httpSvc.get(URL_MAJ_ALLERGENES, null);
  }

  getAuthInfos(): Observable<GestionAuthentificationDto[]> {
    return this.httpSvc.get(URL_GESTION_AUTHENTIFICATION);
  }

  saveAuthInfo(body: GestionAuthentificationDto): Observable<GestionAuthentificationDto> {
    return this.httpSvc.post(URL_GESTION_AUTHENTIFICATION, body)
  }

  deleteAuthInfo(gestionAuthentification: GestionAuthentificationDto): Observable<ResponseWrapper<boolean>> {
    return this.httpSvc.delete(URL_GESTION_AUTHENTIFICATION + '/' + gestionAuthentification.id).pipe(
      catchError(error => this.utils.handleError(error, true)));
  }

  tauxDePerte = () : Observable<ResponseWrapper<boolean>> => {
    return this.httpSvc.get('dolrest/administration/tauxDePerte', null);
  }
}
